/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './asset-units-admin.scss';

/* eslint-disable import/no-unresolved, import/default */

import deviceCredentialsTemplate from '../../../../../device/device-credentials.tpl.html';
import assetUnitsAdminTemplate from './asset-units-admin.tpl.html';
import addDeviceTemplate from './add-device.tpl.html';
import addWeatherStationTemplate from './add-weather-station.tpl.html';
import AutoplaceSensorLinesTemplate from './autoplace-sensor-lines.tpl.html'

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.assetUnitsAdmin', [])
    .directive('agAssetUnitsAdmin', AssetUnitsAdmin)
    .name;

/*@ngInject*/
function AssetUnitsAdmin() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: AssetUnitsAdminController,
        controllerAs: 'vm',
        templateUrl: assetUnitsAdminTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function AssetUnitsAdminController($rootScope, $scope, $document, $window, $mdDialog, $q, $filter, $mdMedia, $log,
                              $translate, agTypes, types, attributeService, userService, assetService, agDeviceService, siloService,
                              aerationService, weatherStationService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.types = types;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.hasData = false;

    vm.assetUnits = [];
    vm.assetUnitsCount = 0;
    vm.allAssetUnits = [];
    vm.selectedAssetUnits = [];

    vm.displayPagination = true;

    vm.currentAssetUnit = null;

    vm.query = {
        order: 'name',
        limit: 5,
        page: 1,
        search: null
    };

    vm.addDeviceAction = {
        name: 'ag.device.add',
        show: true,
        onAction: function($event) {
            vm.addDevice($event);
        },
        icon: 'add'
    };

    vm.addWeatherStationAction = {
        name: 'ag.weather-station.add',
        show: true,
        onAction: function($event) {
            vm.addWeatherStation($event);
        },
        icon: 'ag:weather_station'
    };

    vm.autoplaceSensorLinesAction = {
        name: 'ag.silo.autoplace-sensor-lines',
        show: true,
        onAction: function($event) {
            vm.autoplaceSensorLines($event);
        },
        icon: 'filter_tilt_shift'
    }

    vm.searchAction = {
        name: 'action.search',
        show: true,
        onAction: function() {
            vm.enterFilterMode();
        },
        icon: 'search'
    };

    vm.refreshAction = {
        name: 'action.refresh',
        show: true,
        onAction: function() {
            vm.reloadAssetUnits();
        },
        icon: 'refresh'
    };

    vm.onRowClick = onRowClick;
    vm.isCurrent = isCurrent;
    vm.enterFilterMode = enterFilterMode;
    vm.exitFilterMode = exitFilterMode;
    vm.onReorder = onReorder;
    vm.onPaginate = onPaginate;
    vm.addDevice = addDevice;
    vm.addWeatherStation = addWeatherStation;
    vm.autoplaceSensorLines = autoplaceSensorLines;
    vm.copyDevice = copyDevice;
    vm.moveDevice = moveDevice;
    vm.manageCredentials = manageCredentials;
    vm.deleteAssetUnit = deleteAssetUnit;
    vm.deleteAssetUnits = deleteAssetUnits;
    vm.reloadAssetUnits = reloadAssetUnits;
    vm.updateAssetUnits = updateAssetUnits;

    $scope.$watch(function() { return $mdMedia('gt-xs'); }, function(isGtXs) {
        vm.isGtXs = isGtXs;
    });

    $scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [5, 10, 15];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            vm.assetId = null;
            if (vm.ctx.stateController) {
                vm.assetId = vm.ctx.stateController.getStateParams().entityId;
            }
            vm.ctx.widgetTitle = $translate.instant('ag.asset-unit.asset-units') + '';
            vm.displayPagination = angular.isDefined(vm.ctx.settings.displayPagination) ? vm.ctx.settings.displayPagination : true;
            reloadAssetUnits();
        }
    });

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$watch("vm.query.search", function(newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateAssetUnits();
        }
    });

    $scope.$on('deviceUpdated', function(event, device) {
        assetUnitUpdated(device);
    });

    $scope.$on('weatherStationUpdated', function(event, weatherStation) {
        assetUnitUpdated(weatherStation);
    });

    function assetUnitUpdated(assetUnit) {
        var result = $filter('filter')(vm.allAssetUnits, {id: { id: assetUnit.id.id } }, true);
        if (result && result.length) {
            var prevAssetUnit = result[0];
            var index = vm.allAssetUnits.indexOf(prevAssetUnit);
            vm.allAssetUnits[index] = assetUnit;
            index = vm.assetUnits.indexOf(prevAssetUnit);
            if (index > -1) {
                vm.assetUnits[index] = assetUnit;
            }
        }
    }

    $scope.$watch('vm.selectedAssetUnits.length', function (newLength) {
        var selectionMode = newLength ? true : false;
        if (vm.ctx) {
            if (selectionMode) {
                vm.ctx.hideTitlePanel = true;
            } else if (vm.query.search == null) {
                vm.ctx.hideTitlePanel = false;
            }
        }
    });

    $scope.$on('deviceCopied', function() {
        reloadAssetUnits(true);
    });

    $scope.$on('deviceMoved', function() {
        reloadAssetUnits();
    });

    function onRowClick($event, assetUnit) {
        if (vm.currentAssetUnit != assetUnit) {
            vm.currentAssetUnit = assetUnit;
        }
        vm.ctx.stateController.openRightLayout();
        broadcastUnitSelected(assetUnit);
    }

    function broadcastUnitSelected(unit) {
        var entityId = unit ? unit.id : null;
        var entitySubtype = unit ? unit.type : null;
        var entityName = unit ? unit.name : null;
        $rootScope.$broadcast('assetUnitSelected', entityId, entitySubtype, entityName, vm.assetId, vm.assetType);
    }

    function isCurrent(assetUnit) {
        return (vm.currentAssetUnit && assetUnit) &&
            (vm.currentAssetUnit.id.id === assetUnit.id.id);
    }

    function enterFilterMode () {
        vm.query.search = '';
        vm.ctx.hideTitlePanel = true;
    }

    function exitFilterMode () {
        vm.query.search = null;
        updateAssetUnits();
        vm.ctx.hideTitlePanel = false;
    }

    function onReorder () {
        updateAssetUnits();
    }

    function onPaginate () {
        updateAssetUnits();
    }

    function addDevice($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var excludeDeviceIds = [];
        vm.allAssetUnits.forEach(function(assetUnit) {
            excludeDeviceIds.push(assetUnit.id.id);
        });
        $mdDialog.show({
            controller: AddDeviceController,
            controllerAs: 'vm',
            templateUrl: addDeviceTemplate,
            parent: angular.element($document[0].body),
            locals: {
                excludeDeviceIds: excludeDeviceIds,
                assetId: vm.assetId,
                assetType: vm.assetType
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event,
            onComplete: function () {
                var w = angular.element($window);
                w.triggerHandler('resize');
            }
        }).then(function () {
            reloadAssetUnits();
        }, function () {
        });
    }

    function addWeatherStation($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var excludeEntityIds = [];
        vm.allAssetUnits.forEach(function(assetUnit) {
            excludeEntityIds.push(assetUnit.id.id);
        });

        var stateParams = vm.ctx.stateController.getStateParamsByStateId(agTypes.adminState.site);
        var siteId = stateParams.entityId;

        $mdDialog.show({
            controller: AddWeatherStationController,
            controllerAs: 'vm',
            templateUrl: addWeatherStationTemplate,
            parent: angular.element($document[0].body),
            locals: {
                excludeEntityIds: excludeEntityIds,
                assetId: vm.assetId,
                siteId: siteId
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event,
            onComplete: function () {
                var w = angular.element($window);
                w.triggerHandler('resize');
            }
        }).then(function () {
            reloadAssetUnits();
        }, function () {
        });
    }

    function autoplaceSensorLines($event) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.assetId) {
            vm.assetUnitsPromise = siloService.getSilo(vm.assetId);
            vm.assetUnitsPromise.then(
                function success(siloAsset) {
                    vm.siloAsset = siloAsset;
                    vm.positionProperties = findCablesPositionProperties();
                    $mdDialog.show({
                        controller: AutoplaceSensorLinesController,
                        controllerAs: 'vm',
                        templateUrl: AutoplaceSensorLinesTemplate,
                        parent: angular.element($document[0].body),
                        locals: {
                            allAssetUnits: vm.allAssetUnits,
                            siloAsset: vm.siloAsset,
                            positionProperties: vm.positionProperties,
                            degToRad: degToRad
                        },
                        fullscreen: true,
                        skipHide: true,
                        targetEvent: $event,
                        onComplete: function () {
                            var w = angular.element($window);
                            w.triggerHandler('resize');
                        }
                    }).then(function (positionProperties) {
                        vm.positionProperties = positionProperties;
                        executeAutoplacing().then(
                            function success() {
                                reloadAssetUnits();
                            },
                            function fail() {
                                vm.assetUnitsPromise = null;
                            }
                        );
                    }, function () {
                    });
                },
                function fail() {
                    vm.assetUnitsPromise = null;
                }
            );
        } else {
            reloadAssetUnits();
        }
    }

    function executeAutoplacing() {
        var deferred = $q.defer();
        if (vm.assetId) {
            vm.assetUnitsPromise = siloService.getSiloSensorLines(vm.assetId);
            vm.assetUnitsPromise.then(
                function success(sensorLines) {
                    if (sensorLines && sensorLines.length) {
                        sensorLines = $filter('orderBy')(sensorLines, agTypes.attributes.temperatureSensorLinesClient.lineNum);
                        if (vm.positionProperties.includeMoistureLines || vm.positionProperties.includeCO2Lines) {
                            sensorLines = placeMoistureAndCO2Lines(sensorLines);
                        }

                        var angle1 = 0;
                        var angle2 = 0;
                        var angle3 = 0;
                        var j = 0;
                        vm.assetUnitsPromise = [];
                        for (var i = 0; i < vm.positionProperties.sensorLinesCount; i++) {
                            if (sensorLines[i]) {
                                if (vm.positionProperties.zeroRingLinesCount && i === 0) {
                                    sensorLines[i].positionX = 0;
                                    sensorLines[i].positionY = 0;
                                    if (vm.positionProperties.zeroRingLinesLength) {
                                        sensorLines[i].length = vm.positionProperties.zeroRingLinesLength;
                                    }
                                    j = 1;
                                } else if (vm.positionProperties.firstRingLinesCount && i < vm.positionProperties.firstRingLinesCount + j) {
                                    sensorLines[i].positionX = vm.positionProperties.firstRingRadius * Math.cos(degToRad(angle1));
                                    sensorLines[i].positionY = vm.positionProperties.firstRingRadius * Math.sin(degToRad(angle1));
                                    if (vm.positionProperties.firstRingLinesLength) {
                                        sensorLines[i].length = vm.positionProperties.firstRingLinesLength;
                                    }
                                    angle1 += vm.positionProperties.firstRingAngle;
                                } else if (vm.positionProperties.secondRingLinesCount && i < vm.positionProperties.secondRingLinesCount + vm.positionProperties.firstRingLinesCount + j) {
                                    sensorLines[i].positionX = vm.positionProperties.secondRingRadius * Math.cos(degToRad(angle2));
                                    sensorLines[i].positionY = vm.positionProperties.secondRingRadius * Math.sin(degToRad(angle2));
                                    if (vm.positionProperties.secondRingLinesLength) {
                                        sensorLines[i].length = vm.positionProperties.secondRingLinesLength;
                                    }
                                    angle2 += vm.positionProperties.secondRingAngle;
                                } else if (vm.positionProperties.thirdRingLinesCount && i < vm.positionProperties.thirdRingLinesCount + vm.positionProperties.secondRingLinesCount +
                                    vm.positionProperties.firstRingLinesCount + j) {
                                    sensorLines[i].positionX = vm.positionProperties.thirdRingRadius * Math.cos(degToRad(angle3));
                                    sensorLines[i].positionY = vm.positionProperties.thirdRingRadius * Math.sin(degToRad(angle3));
                                    if (vm.positionProperties.thirdRingLinesLength) {
                                        sensorLines[i].length = vm.positionProperties.thirdRingLinesLength;
                                    }
                                    angle3 += vm.positionProperties.thirdRingAngle;
                                }

                                sensorLines[i].positionZ = 0;

                                var sensorLinePromise = agDeviceService.saveSensorLines(sensorLines[i], vm.assetId);
                                vm.assetUnitsPromise.push(sensorLinePromise);
                            } else {
                                if (vm.positionProperties.firstRingLinesCount && i < vm.positionProperties.firstRingLinesCount + j) {
                                    angle1 += vm.positionProperties.firstRingAngle;
                                } else if (vm.positionProperties.secondRingLinesCount && i < vm.positionProperties.secondRingLinesCount + vm.positionProperties.firstRingLinesCount + j) {
                                    angle2 += vm.positionProperties.secondRingAngle;
                                } else if (vm.positionProperties.thirdRingLinesCount && i < vm.positionProperties.thirdRingLinesCount + vm.positionProperties.secondRingLinesCount +
                                    vm.positionProperties.firstRingLinesCount + j) {
                                    angle3 += vm.positionProperties.thirdRingAngle;
                                }
                            }
                        }
                        $q.all(vm.assetUnitsPromise).then(
                            function success(sensorLines) {
                                deferred.resolve(sensorLines);
                            },
                            function fail() {
                                deferred.reject();
                            }
                        );
                    }
                },
                function fail() {
                    deferred.reject();
                }
            );
        }
        return deferred.promise;
    }

    function placeMoistureAndCO2Lines(allSensorLines) {
        var result = [];
        var moistureLines = [];
        var co2Lines = [];
        allSensorLines.forEach((line) => {
            if (line.type === agTypes.deviceType.temperatureSensorLines) {
                result.push(line);
            } else if (line.type === agTypes.deviceType.moistureSensorLines) {
                moistureLines.push(line);
            } else if (line.type === agTypes.deviceType.co2SensorLines) {
                co2Lines.push(line);
            }
        });

        var firstRingIndex, secondRingIndex, thirdRingIndex;
        if (vm.positionProperties.zeroRingLinesCount) {
            if (moistureLines[0]) {
                result.unshift(moistureLines.shift());
            }
            if (co2Lines[0]) {
                result.unshift(co2Lines.shift());
            }
        }

        if (vm.positionProperties.firstRingLinesCount) {
            firstRingIndex = vm.positionProperties.zeroRingLinesCount ? 1 : 0;
            if (moistureLines[0]) {
                result.splice(firstRingIndex, 0, moistureLines.shift());
            }
            if (co2Lines[0]) {
                result.splice(firstRingIndex, 0, co2Lines.shift());
            }
        }

        if (vm.positionProperties.secondRingLinesCount) {
            secondRingIndex = firstRingIndex + vm.positionProperties.firstRingLinesCount + Math.floor(vm.positionProperties.secondRingLinesCount/2);
            if (moistureLines[0]) {
                if (result[secondRingIndex]) {
                    result.splice(secondRingIndex, 0, moistureLines.shift());
                } else {
                    result[secondRingIndex] = moistureLines.shift();
                }
            }
            if (co2Lines[0]) {
                if (result[secondRingIndex]) {
                    result.splice(secondRingIndex, 0, co2Lines.shift());
                } else {
                    result[secondRingIndex] = co2Lines.shift();
                }
            }
        }

        if (vm.positionProperties.thirdRingLinesCount) {
            thirdRingIndex = firstRingIndex + vm.positionProperties.firstRingLinesCount + vm.positionProperties.secondRingLinesCount;
            if (moistureLines[0]) {
                if (result[thirdRingIndex]) {
                    result.splice(thirdRingIndex, 0, moistureLines.shift());
                } else {
                    result[thirdRingIndex] = moistureLines.shift();
                }
            }
            if (co2Lines[0]) {
                if (result[thirdRingIndex]) {
                    result.splice(thirdRingIndex, 0, co2Lines.shift());
                } else {
                    result[thirdRingIndex] = co2Lines.shift();
                }
            }
        }
        return result;
    }

    function copyDevice($event, device) {
        agDeviceService.copyDeviceDialog($event, device).then(
            function() {
                reloadAssetUnits();
            }
        );
    }

    function moveDevice($event, device) {
        agDeviceService.moveDeviceDialog($event, device, vm.assetId).then(
            function() {
                reloadAssetUnits();
            }
        );
    }

    function manageCredentials($event, device) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'ManageDeviceCredentialsController',
            controllerAs: 'vm',
            templateUrl: deviceCredentialsTemplate,
            locals: {deviceId: device.id.id, isReadOnly: false},
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event
        }).then(function () {
        }, function () {
        });
    }

    function deleteAssetUnit($event, assetUnit) {
        if ($event) {
            $event.stopPropagation();
        }
        if (assetUnit) {
            var name = assetUnit.name;
            var title;
            var content;
            if (vm.assetType === agTypes.assetType.silo || vm.assetType === agTypes.assetType.weatherStation) {
                title = $translate.instant('ag.device.delete-device-title', {deviceName: name});
                content = $translate.instant('ag.device.delete-device-text');
            } else if (vm.assetType === agTypes.assetType.aeration) {
                if (assetUnit.id.entityType === types.entityType.device && assetUnit.type === agTypes.deviceType.relay) {
                    title = $translate.instant('ag.device.delete-relay-relation-title', {deviceName: name});
                    content = $translate.instant('ag.device.delete-relay-relation-text');
                } else if (assetUnit.id.entityType === types.entityType.asset && assetUnit.type === agTypes.assetType.weatherStation) {
                    title = $translate.instant('ag.weather-station.delete-weather-station-relation-title', {assetName: name});
                    content = $translate.instant('ag.weather-station.delete-weather-station-relation-text');
                }
            }
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                var deletePromise;
                if (vm.assetType === agTypes.assetType.silo || vm.assetType === agTypes.assetType.weatherStation) {
                    deletePromise = agDeviceService.deleteDevice(assetUnit.id);
                } else if (vm.assetType === agTypes.assetType.aeration) {
                    if (assetUnit.id.entityType === types.entityType.device && assetUnit.type === agTypes.deviceType.relay) {
                        deletePromise = agDeviceService.deleteRelayRelation(assetUnit.id, vm.assetId);
                    } else if (assetUnit.id.entityType === types.entityType.asset && assetUnit.type === agTypes.assetType.weatherStation) {
                        deletePromise = weatherStationService.deleteWeatherStationRelation(assetUnit.id, vm.assetId);
                    }
                }
                deletePromise.then(
                    function success() {
                        reloadAssetUnits();
                    }
                );
            });
        }
    }

    function deleteAssetUnits($event) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.selectedAssetUnits && vm.selectedAssetUnits.length > 0) {
            var title;
            var content;
            if (vm.assetType === agTypes.assetType.silo || vm.assetType === agTypes.assetType.weatherStation) {
                title = $translate.instant('ag.device.delete-devices-title', {count: vm.selectedAssetUnits.length}, 'messageformat');
                content = $translate.instant('ag.device.delete-devices-text');
            } else if (vm.assetType === agTypes.assetType.aeration) {
                title = $translate.instant('ag.asset-unit.delete-asset-unit-relations-title', {count: vm.selectedAssetUnits.length}, 'messageformat');
                content = $translate.instant('ag.asset-unit.delete-asset-unit-relations-text');
            }
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                var tasks = [];
                for (var i=0;i<vm.selectedAssetUnits.length;i++) {
                    var assetUnit = vm.selectedAssetUnits[i];
                    var deletePromise;
                    if (vm.assetType === agTypes.assetType.silo || vm.assetType === agTypes.assetType.weatherStation) {
                        deletePromise = agDeviceService.deleteDevice(assetUnit.id);
                    } else if (vm.assetType === agTypes.assetType.aeration) {
                        if (assetUnit.id.entityType === types.entityType.device && assetUnit.type === agTypes.deviceType.relay) {
                            deletePromise = agDeviceService.deleteRelayRelation(assetUnit.id, vm.assetId);
                        } else if (assetUnit.id.entityType === types.entityType.asset && assetUnit.type === agTypes.assetType.weatherStation) {
                            deletePromise = weatherStationService.deleteWeatherStationRelation(assetUnit.id, vm.assetId);
                        }
                    }
                    tasks.push(deletePromise);
                }
                $q.all(tasks).then(function () {
                    reloadAssetUnits();
                });

            });
        }
    }

    function reloadAssetUnits (keepSelection) {
        vm.allAssetUnits.length = 0;
        vm.assetUnits.length = 0;
        if (!keepSelection) {
            vm.currentAssetUnit = null;
        }
        if (vm.assetId) {
            assetService.getAsset(vm.assetId.id).then(
                function success(asset) {
                    vm.assetType = asset.type;
                    if (vm.assetType === agTypes.assetType.silo) {
                        vm.addDeviceAction.icon = 'add';
                        vm.ctx.widgetActions = [ vm.addDeviceAction, vm.autoplaceSensorLinesAction, vm.searchAction, vm.refreshAction ];
                        vm.assetUnitsPromise = siloService.getSiloDevices(vm.assetId);
                    } else if (vm.assetType === agTypes.assetType.aeration) {
                        vm.addDeviceAction.icon = 'devices_other';
                        vm.ctx.widgetActions = [ vm.addWeatherStationAction, vm.addDeviceAction, vm.searchAction, vm.refreshAction ];
                        vm.assetUnitsPromise = aerationService.getAerationAssetUnits(vm.assetId);
                    } else if (vm.assetType === agTypes.assetType.weatherStation) {
                        vm.addDeviceAction.icon = 'add';
                        vm.ctx.widgetActions = [ vm.addDeviceAction, vm.searchAction, vm.refreshAction ];
                        vm.assetUnitsPromise = weatherStationService.getWeatherStationDevices(vm.assetId);
                    }
                    vm.assetUnitsPromise.then(
                        function success(allAssetUnits) {
                            vm.allAssetUnits = allAssetUnits;
                            vm.selectedAssetUnits = [];
                            vm.updateAssetUnits();
                            vm.assetUnitsPromise = null;
                            if (vm.assetType === agTypes.assetType.silo) {
                                let moistureMatch =  $filter('filter')(allAssetUnits, {type: agTypes.deviceType.moistureSensorLines });
                                let co2Match =  $filter('filter')(allAssetUnits, {type: agTypes.deviceType.co2SensorLines });
                                let cropLevelMatch = $filter('filter')(allAssetUnits, {type: agTypes.deviceType.levelIndicator });
                                
                                let headSpaceMatch = allAssetUnits.filter(
                                assetUnit =>
                                    assetUnit.type === agTypes.deviceType.headSpaceSensor ||
                                    assetUnit.type === agTypes.deviceType.headSpaceSensor2000
                                );

                                attributeService.saveEntityAttributes(types.entityType.asset, vm.assetId.id, types.attributesScope.server.value,
                                    [{key: agTypes.attributes.silo.hasMoistureCables, value: !!moistureMatch.length},
                                        {key: agTypes.attributes.silo.hasCO2Cables, value: !!co2Match.length},
                                        {key: agTypes.attributes.silo.hasLevelIndicator, value: !!cropLevelMatch.length},
                                        {key: agTypes.attributes.silo.hasHeadSpaceSensor, value: !!headSpaceMatch.length}]).then(() => {
                                });
                            }
                        },
                        function fail() {
                            vm.allAssetUnits = [];
                            vm.selectedAssetUnits = [];
                            vm.updateAssetUnits();
                            vm.assetUnitsPromise = null;
                        }
                    )
                },
                function fail() {
                    vm.ctx.widgetActions = [];
                    vm.assetId = null;
                    vm.assetType = null;
                    vm.updateAssetUnits();
                }
            );

        } else {
            vm.ctx.widgetActions = [];
            vm.assetType = null;
            vm.updateAssetUnits();
        }
    }

    function updateAssetUnits () {
        if (vm.assetType) {
            vm.ctx.widgetTitle = $translate.instant(vm.assetType === agTypes.assetType.aeration ? 'ag.aeration.aeration-relations' : 'ag.device.devices') + '' ;
        }
        vm.selectedAssetUnits = [];
        var result = $filter('orderBy')(vm.allAssetUnits, vm.query.order);
        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }
        vm.assetUnitsCount = result.length;

        if (vm.displayPagination) {
            var startIndex = vm.query.limit * (vm.query.page - 1);
            vm.assetUnits = result.slice(startIndex, startIndex + vm.query.limit);
        } else {
            vm.assetUnits = result;
        }
    }

    function findCablesPositionProperties() {
        var siloDiameter = vm.siloAsset.diameter;
        var properties = agTypes.cablesPositionProperties;

        for (var i = 0; i < properties.length; i++) {
            if (siloDiameter <= properties[i].siloDiameter) {
                return properties[i];
            }
        }
        return properties[properties.length - 1];
    }

    function degToRad(angleInDeg) {
        if (angleInDeg >= 180) {
            angleInDeg -= 360;
        }
        return (angleInDeg * Math.PI) / 180;
    }
}

/*@ngInject*/
function AddDeviceController($scope, $mdDialog, $document, $q, $translate, types, agTypes,
                             agDeviceService, entityService, entityRelationService, excludeDeviceIds, assetId, assetType) {

    var vm = this;

    vm.types = types;
    vm.agTypes = agTypes;
    vm.excludeDeviceIds = excludeDeviceIds;
    vm.assetId = assetId;
    vm.assetType = assetType;
    vm.addLoading = false;

    vm.existingChannelsNum = null;

    vm.device = {
        id: {
            entityType: types.entityType.device
        },
        type: null
    };
    if (assetType === agTypes.assetType.silo) {
        vm.deviceTypes = [agTypes.deviceType.temperatureSensorLines, agTypes.deviceType.moistureSensorLines, agTypes.deviceType.co2SensorLines, agTypes.deviceType.levelIndicator, agTypes.deviceType.headSpaceSensor, agTypes.deviceType.headSpaceSensor2000];
    } else if (assetType === agTypes.assetType.aeration) {
        vm.deviceTypes = [agTypes.deviceType.relay];
        vm.device.type = agTypes.deviceType.relay;
        vm.existingDeviceType = agTypes.deviceType.relay;
        $scope.$watch('vm.existingDeviceId', function (newExistingDeviceId) {
            if (newExistingDeviceId) {
                agDeviceService.getRelay({id: newExistingDeviceId, entityType: types.entityType.device}).then(
                    function success(relay) {
                        vm.existingChannelsNum = relay.channelsNum;
                        vm.assignedChannels = [];
                        for (var i = 0; i < relay.assignedSystemsInfo.length; i++) {
                            if (relay.assignedSystemsInfo[i].channelIds && relay.assignedSystemsInfo[i].channelIds.length) {
                                vm.assignedChannels = vm.assignedChannels.concat(relay.assignedSystemsInfo[i].channelIds);
                            }
                        }
                    },
                    function fail() {
                        vm.existingChannelsNum = null;
                    }
                );
            } else {
                vm.existingChannelsNum = null;
            }
        });
    } else if (assetType === agTypes.assetType.weatherStation) {
        vm.deviceTypes = [agTypes.deviceType.weatherStation];
    }

    vm.getNumber = getNumber;
    vm.add = add;
    vm.cancel = cancel;
    vm.isChannelAssigned = isChannelAssigned;

    function getNumber(num) {
        return new Array(num);
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function add($event) {
        var promise;
        if (vm.assetType === agTypes.assetType.silo) {
            promise = addExistingDevices($event);
        } else {
            promise = addExisting($event);
        }
        promise.then(
            () => {
                vm.addLoading = false;
                $scope.existingDeviceForm.$setPristine();
                $mdDialog.hide();
            },
            () => {
                vm.addLoading = false;
            }
        );
    }

    function addExistingDevices($event) {
        var deferred = $q.defer();
        var checkParentsTasks = [];
        vm.assignedDeviceIds = [];
        vm.addLoading = true;
        for (var i = 0; i < vm.existingDeviceIds.length; i++) {
            checkParentsTasks.push(agDeviceService.findParentSilo(vm.existingDeviceIds[i]));
        }
        $q.all(checkParentsTasks).then(
            (parents) => {
                if (parents && parents.length) {
                    for (var i = 0; i < parents.length; i++) {
                        if (parents[i]) {
                            vm.assignedDeviceIds.push(vm.existingDeviceIds[i]);
                        }
                    }
                    if (vm.assignedDeviceIds.length) {
                        entityService.getEntities(types.entityType.device, vm.assignedDeviceIds).then(
                            (assignedDevices) => {
                                vm.addLoading = false;
                                var title = $translate.instant('ag.device.already-assigned-to-other-silos', {count: assignedDevices.length}, 'messageformat');
                                var contentString = "";
                                for (var i = 0; i < assignedDevices.length; i++) {
                                    contentString += assignedDevices[i].name;
                                    contentString += '</br>';
                                }
                                var alert = $mdDialog.alert()
                                    .targetEvent($event)
                                    .title(title)
                                    .htmlContent(contentString)
                                    .ariaLabel(title)
                                    .ok($translate.instant('action.ok'))
                                    .targetEvent($event);
                                alert._options.skipHide = true;
                                alert._options.fullscreen = true;
                                $mdDialog.show(alert).then(
                                    () => {
                                        for (var i = vm.existingDeviceIds.length - 1; i >= 0; i--) {
                                            if (vm.assignedDeviceIds.indexOf(vm.existingDeviceIds[i]) !== -1) {
                                                vm.existingDeviceIds.splice(i, 1);
                                            }
                                        }
                                        deferred.reject();
                                    }
                                );
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    } else {
                        var saveRelationTasks = [];
                        for (var j = 0; j < vm.existingDeviceIds.length; j++) {
                            var deviceId = {
                                id: vm.existingDeviceIds[j],
                                entityType: types.entityType.device
                            }
                            var relation = {
                                from: vm.assetId,
                                to: deviceId,
                                type: types.entityRelationType.contains
                            };
                            saveRelationTasks.push(entityRelationService.saveRelation(relation));
                        }
                        $q.all(saveRelationTasks).then(
                            () => {
                                deferred.resolve();
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                        deferred.resolve();
                    }
                }
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function addExisting($event) {
        var deferred = $q.defer();
        var findParentPromise;
        if (vm.assetType === agTypes.assetType.silo) {
            findParentPromise = agDeviceService.findParentSilo(vm.existingDeviceId);
        } else if (vm.assetType === agTypes.assetType.aeration) {
            findParentPromise = agDeviceService.findParentAeration(vm.existingDeviceId);
        } else if (vm.assetType === agTypes.assetType.weatherStation) {
            findParentPromise = agDeviceService.findParentWeatherStation(vm.existingDeviceId);
        }
        findParentPromise.then(
            function success(parent) {
                var entityId = {
                    id: vm.existingDeviceId,
                    entityType: types.entityType.device
                };
                if (vm.assetType === agTypes.assetType.silo || vm.assetType === agTypes.assetType.weatherStation) {
                    if (parent) {
                        var name = parent.name;
                        var title;
                        var content;
                        if (vm.assetType === agTypes.assetType.silo) {
                            title = $translate.instant('ag.device.already-related-to-different-silo-title', {siloName: name});
                            content = $translate.instant('ag.device.already-related-to-different-silo-text');
                        } else {
                            title = $translate.instant('ag.device.already-related-to-different-weather-station-title', {weatherStationName: name});
                            content = $translate.instant('ag.device.already-related-to-different-weather-station-text');
                        }
                        var confirm = $mdDialog.confirm()
                            .targetEvent($event)
                            .title(title)
                            .htmlContent(content)
                            .ariaLabel(title)
                            .cancel($translate.instant('action.no'))
                            .ok($translate.instant('action.yes'))
                            .targetEvent($event);
                        confirm._options.skipHide = true;
                        confirm._options.fullscreen = true;
                        $mdDialog.show(confirm).then(function () {
                            entityService.moveEntity(entityId, parent.id, vm.assetId).then(
                                function success() {
                                    deferred.resolve();
                                },
                                function fail() {
                                    deferred.reject();
                                }
                            );
                        });
                    } else {
                        var relation = {
                            from: vm.assetId,
                            to: entityId,
                            type: types.entityRelationType.contains
                        };
                        entityRelationService.saveRelation(relation).then(
                            function success() {
                                deferred.resolve();
                            },
                            function fail() {
                                deferred.reject();
                            }
                        );
                    }
                } else if (vm.assetType === agTypes.assetType.aeration) {
                    relation = {
                        from: vm.assetId,
                        to: entityId,
                        type: agTypes.relationType.relay,
                        additionalInfo: {
                            channelIds: vm.channelIds
                        }
                    };
                    entityRelationService.saveRelation(relation).then(
                        function success() {
                            deferred.resolve();
                        },
                        function fail() {
                            deferred.reject();
                        }
                    );
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function isChannelAssigned(channelIndex) {
        if (vm.assignedChannels) {
            return vm.assignedChannels.indexOf(channelIndex) !== -1;
        }
        return false;
    }
}

/*@ngInject*/
function AddWeatherStationController($scope, $mdDialog, types, agTypes, entityRelationService, siteId, assetId, excludeEntityIds) {

    var vm = this;

    vm.types = types;
    vm.agTypes = agTypes;
    vm.excludeEntityIds = excludeEntityIds;
    vm.assetId = assetId;
    vm.siteId = siteId;

    vm.add = add;
    vm.cancel = cancel;

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        var relation = {
            from: vm.assetId,
            to: vm.targetWeatherStationId,
            type: agTypes.relationType.weatherStation,
            additionalInfo: {
            }
        };
        entityRelationService.saveRelation(relation).then(
            function success() {
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            }
        );
    }
}

/*@ngInject*/
function AutoplaceSensorLinesController($translate, $mdDialog, siloAsset, allAssetUnits, positionProperties, degToRad) {

    var vm = this;

    vm.setLength = false;
    vm.allAssetUnits = allAssetUnits;
    vm.siloAsset = siloAsset;
    vm.positionProperties = positionProperties;
    vm.currentPositionProperties = angular.copy(vm.positionProperties);

    vm.sensorLinesCount = 0;

    if (vm.positionProperties.zeroRingLinesCount) {
        vm.sensorLinesCount += vm.positionProperties.zeroRingLinesCount;
        vm.currentPositionProperties.zeroRingLinesLength = vm.siloAsset.totalheight - 1;
    }
    if (vm.positionProperties.firstRingLinesCount) {
        vm.sensorLinesCount += vm.positionProperties.firstRingLinesCount;
        firstRingRadiusChanging();
    }
    if (vm.positionProperties.secondRingLinesCount) {
        vm.sensorLinesCount += vm.positionProperties.secondRingLinesCount;
        secondRingRadiusChanging();
    }
    if (vm.positionProperties.thirdRingLinesCount) {
        vm.sensorLinesCount += vm.positionProperties.thirdRingLinesCount;
        thirdRingRadiusChanging();
    }

    vm.title = $translate.instant('ag.silo.autoplace-sensor-lines-title', {count: vm.sensorLinesCount}, 'messageformat');

    vm.autoplaceLines = autoplaceLines;
    vm.firstRingRadiusChanging = firstRingRadiusChanging;
    vm.secondRingRadiusChanging = secondRingRadiusChanging;
    vm.thirdRingRadiusChanging = thirdRingRadiusChanging;
    vm.cancel = cancel;

    function firstRingRadiusChanging() {
        vm.currentPositionProperties.firstRingLinesLength = findSensorLineLength(vm.currentPositionProperties.firstRingRadius);
    }

    function secondRingRadiusChanging() {
        vm.currentPositionProperties.secondRingLinesLength = findSensorLineLength(vm.currentPositionProperties.secondRingRadius);
    }

    function thirdRingRadiusChanging() {
        vm.currentPositionProperties.thirdRingLinesLength = findSensorLineLength(vm.currentPositionProperties.thirdRingRadius);
    }

    function autoplaceLines() {
        vm.positionProperties = vm.currentPositionProperties;
        vm.positionProperties.sensorLinesCount = vm.sensorLinesCount;
        vm.positionProperties.includeMoistureLines = vm.includeMoistureLines;
        vm.positionProperties.includeCO2Lines = vm.includeCO2Lines;
        $mdDialog.hide(vm.positionProperties);
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function findSensorLineLength(r) {
        var h = vm.siloAsset.totalheight - vm.siloAsset.eaveheight;
        var R = vm.siloAsset.diameter * 0.5;
        var distToRoof = h * (R - r) / R;
        var length = vm.siloAsset.eaveheight + distToRoof - 1;

        if (vm.siloAsset.hopper) {
            var innerHopperAngle = Math.PI / 2 - degToRad(vm.siloAsset.hopperangle);
            var distToHopper = (R - r) * Math.tan(innerHopperAngle);
            if (distToHopper > vm.siloAsset.hopperheight) {
                distToHopper = vm.siloAsset.hopperheight;
            }
            length = vm.siloAsset.eaveheight - (vm.siloAsset.hopperheight - distToHopper) + distToRoof - 1;
        }
        return +length.toFixed(1);
    }
}